[
  {
    "id": 1,
    "childs": [
      {
        "id": 2,
        "childs": [
          {
            "id": 25,
            "childs": [
              {
                "id": 26,
                "childs": [
                  {
                    "id": 28,
                    "childs": [
                      {
                        "id": 183,
                        "childs": []
                      }
                    ]
                  },
                  {
                    "id": 27,
                    "childs": []
                  }
                ]
              },
              {
                "id": 153,
                "childs": []
              }
            ]
          },
          {
            "id": 21,
            "childs": []
          },
          {
            "id": 22,
            "childs": []
          },
          {
            "id": 117,
            "childs": [
              {
                "id": 159,
                "childs": []
              },
              {
                "id": 181,
                "childs": [
                  {
                    "id": 182,
                    "childs": []
                  }
                ]
              }
            ]
          },
          {
            "id": 42,
            "childs": [
              {
                "id": 43,
                "childs": [
                  {
                    "id": 45,
                    "childs": []
                  },
                  {
                    "id": 44,
                    "childs": [
                      {
                        "id": 83,
                        "childs": []
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      { "id": 109, "childs": [] },
      {
        "id": 62,
        "childs": [
          {
            "id": 63,
            "childs": [
              {
                "id": 141,
                "childs": []
              }
            ]
          },
          {
            "id": 205,
            "childs": []
          }
        ]
      },
      {
        "id": 18,
        "childs": [],
        "url": "/picture/%PICTURE_ID%"
      },
      {
        "id": 157,
        "childs": []
      },
      {
        "id": 19,
        "childs": [{ "id": 20, "childs": [] }]
      },
      {
        "id": 51,
        "childs": [
          {
            "id": 209,
            "childs": [
              {
                "id": 210,
                "childs": []
              }
            ]
          }
        ]
      },
      {
        "id": 60,
        "childs": [{ "id": 134, "childs": [] }, { "id": 135, "childs": [] }]
      },
      { "id": 61, "childs": [] },
      {
        "id": 67,
        "childs": [
          {
            "id": 68,
            "childs": [
              { "id": 69, "childs": [] },
              { "id": 70, "childs": [] },
              { "id": 120, "childs": [] }
            ]
          },
          {
            "id": 71,
            "childs": []
          },
          {
            "id": 74,
            "childs": []
          },
          {
            "id": 75,
            "childs": []
          },
          {
            "id": 77,
            "childs": []
          },
          { "id": 97, "childs": [] },
          {
            "id": 100,
            "childs": [{ "id": 101, "childs": [] }, { "id": 142, "childs": [] }]
          },
          { "id": 107, "childs": [] },
          {
            "id": 114,
            "childs": []
          },
          {
            "id": 119,
            "childs": []
          },
          {
            "id": 73,
            "childs": [
              {
                "id": 72,
                "childs": [
                  {
                    "id": 148,
                    "childs": []
                  },
                  {
                    "id": 149,
                    "childs": []
                  }
                ]
              }
            ]
          },
          {
            "id": 202,
            "childs": []
          },
          {
            "id": 203,
            "childs": []
          },
          {
            "id": 131,
            "childs": [
              {
                "id": 78,
                "childs": [
                  {
                    "id": 144,
                    "childs": []
                  },
                  {
                    "id": 178,
                    "childs": []
                  },
                  {
                    "id": 215,
                    "childs": []
                  }
                ]
              },
              { "id": 163, "childs": [] }
            ]
          },
          {
            "id": 212,
            "childs": []
          },
          {
            "id": 110,
            "childs": []
          }
        ]
      },
      { "id": 105, "childs": [] },
      { "id": 106, "childs": [] },
      {
        "id": 87,
        "childs": [
          {
            "id": 91,
            "childs": []
          },
          {
            "id": 29,
            "childs": [{ "id": 30, "childs": [] }]
          },
          {
            "id": 89,
            "childs": [{ "id": 93, "childs": [] }]
          },
          {
            "id": 124,
            "childs": []
          },
          {
            "id": 211,
            "childs": []
          },
          {
            "id": 48,
            "childs": [
              {
                "id": 129,
                "childs": []
              },
              { "id": 54, "childs": [] },
              {
                "id": 123,
                "childs": []
              },
              {
                "id": 49,
                "childs": [
                  {
                    "id": 80,
                    "childs": []
                  },
                  {
                    "id": 128,
                    "childs": []
                  },
                  {
                    "id": 81,
                    "childs": []
                  }
                ]
              },
              {
                "id": 94,
                "childs": []
              },
              {
                "id": 55,
                "childs": [
                  {
                    "id": 56,
                    "childs": []
                  }
                ]
              },
              {
                "id": 133,
                "childs": []
              },
              {
                "id": 137,
                "childs": []
              },
              {
                "id": 188,
                "childs": []
              },
              { "id": 130, "childs": [] },
              {
                "id": 57,
                "childs": []
              },
              {
                "id": 198,
                "childs": []
              }
            ]
          },
          {
            "id": 136,
            "childs": []
          },
          {
            "id": 90,
            "childs": []
          }
        ]
      },
      {
        "id": 10,
        "childs": [
          {
            "id": 58,
            "childs": [],
            "url": "/%BRAND_CATNAME%/%DPBRAND_CATNAME%/"
          },
          {
            "id": 59,
            "childs": [
              {
                "id": 66,
                "childs": [
                  {
                    "id": 193,
                    "childs": [],
                    "url": "/%BRAND_CATNAME%/%DESIGN_PROJECT_CATNAME%/%PICTURE_ID%"
                  }
                ],
                "url": "/%BRAND_CATNAME%/%DESIGN_PROJECT_CATNAME%/pictures/"
              }
            ],
            "url": "/%BRAND_CATNAME%/%DESIGN_PROJECT_CATNAME%/"
          },
          {
            "id": 33,
            "childs": [
              {
                "id": 34,
                "childs": [
                  {
                    "id": 194,
                    "childs": [],
                    "url": "/%BRAND_CATNAME%/%CAR_CATNAME%/pictures/%PICTURE_ID%"
                  }
                ],
                "url": "%ALL_PICTURES_URL%"
              },
              {
                "id": 36,
                "childs": [],
                "url": "/%BRAND_CATNAME%/%CAR_CATNAME%/specifications/"
              }
            ],
            "url": "/%BRAND_CATNAME%/%CAR_CATNAME%/"
          },
          {
            "id": 14,
            "childs": [
              {
                "id": 138,
                "childs": [],
                "url": "/%BRAND_CATNAME%/cars/%CAR_TYPE_CATNAME%/"
              }
            ],
            "url": "/%BRAND_CATNAME%/cars/"
          },
          {
            "id": 37,
            "childs": [],
            "url": "/%BRAND_CATNAME%/concepts/"
          },
          {
            "id": 39,
            "childs": [
              {
                "id": 192,
                "childs": [],
                "url": "/%BRAND_CATNAME%/logotypes/%PICTURE_ID%"
              }
            ],
            "url": "/%BRAND_CATNAME%/logotypes/"
          },
          {
            "id": 40,
            "childs": [
              {
                "id": 190,

                "childs": [],
                "url": "/%BRAND_CATNAME%/mixed/%PICTURE_ID%"
              }
            ],
            "url": "/%BRAND_CATNAME%/mixed/"
          },
          {
            "id": 15,
            "childs": [],
            "url": "/%BRAND_CATNAME%/recent/"
          },
          {
            "id": 164,
            "childs": [
              {
                "id": 165,
                "childs": [
                  {
                    "id": 166,
                    "childs": [
                      {
                        "id": 167,

                        "childs": [],
                        "url": "/%BRAND_CATNAME%/mosts/%MOST_CATNAME%/%CAR_TYPE_CATNAME%/%YEAR_CATNAME%"
                      }
                    ],
                    "url": "/%BRAND_CATNAME%/mosts/%MOST_CATNAME%/%CAR_TYPE_CATNAME%"
                  }
                ],
                "url": "/%BRAND_CATNAME%/mosts/%MOST_CATNAME%"
              }
            ],
            "url": "/%BRAND_CATNAME%/mosts/"
          },
          {
            "id": 41,
            "childs": [
              {
                "id": 191,
                "childs": [],
                "url": "/%BRAND_CATNAME%/other/%PICTURE_ID%"
              }
            ],
            "url": "/%BRAND_CATNAME%/other/"
          },
          {
            "id": 208,
            "childs": [],
            "url": "/%BRAND_CATNAME%/engines"
          }
        ],
        "url": "/%BRAND_CATNAME%/"
      },
      {
        "id": 31,
        "childs": [{ "id": 32, "childs": [] }]
      },
      {
        "id": 102,
        "childs": [
          { "id": 189, "childs": [] },
          {
            "id": 103,
            "childs": []
          }
        ]
      },
      { "id": 161, "childs": [] },
      {
        "id": 173,
        "childs": []
      },
      {
        "id": 174,
        "childs": []
      },
      { "id": 76, "childs": [] },
      {
        "id": 52,
        "childs": [{ "id": 53, "childs": [] }]
      },
      { "id": 122, "childs": [] },
      { "id": 79, "childs": [] },
      { "id": 196, "childs": [] },
      {
        "id": 197,
        "childs": []
      },
      { "id": 201, "childs": [] },
      { "id": 204, "childs": [] },
      {
        "id": 214,
        "childs": [
          {
            "id": 213,
            "childs": []
          }
        ]
      }
    ]
  }
]
